import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Turnero from "../../components/Turnero";

class TurneroContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      indiceDiaSelected:
        this.props.listaFechaHora && this.props.listaFechaHora.length > 0 ? 0 : undefined,
      idDiaSelected:
        this.props.listaFechaHora && this.props.listaFechaHora.length > 0
          ? this.props.listaFechaHora[0].idDiaCalendario
          : undefined,
      index: 2,
      cantItemShow: 3, //cantidad de dias a msotrar
      idHorarioSelected: undefined,
      indiceHorarioSelected: undefined,
      showModalTopeDias: false,
    };

    if (
      this.state.indiceDiaSelected !== undefined &&
      this.props.listaFechaHora !== undefined &&
      this.props.listaFechaHora.length > 0
    ) {
      this.props.handleOnClickDia(
        this.props.listaFechaHora[this.state.indiceDiaSelected],
        this.state.indiceDiaSelected
      );
    }
  }

  handleOnClickDia = (item, indice) => {
    this.setState({ idDiaSelected: item.idDiaCalendario, indiceDiaSelected: indice }, () => {
      this.props.handleOnClickDia(item);
    });
  };

  handleOnClickSiguiente = () => {
    let value = this.state.index + 1;
    this.setState({ index: value });
  };

  handleOnClickAnterior = () => {
    let value = this.state.index - 1;
    this.setState({ index: value });
  };

  handleOnClickHorario = (item, indice) => {
    this.setState({ idHorarioSelected: item.idHorario, indiceHorarioSelected: indice }, () => {
      this.props.handleOnClickHorario(item);
    });
  };

  handleShowMsgTopeDias = () => {
    let showModal = this.state.showModalTopeDias;
    this.setState({ showModalTopeDias: !showModal });
  };

  render() {
    return (
      <Turnero
        listaFechaHora={this.props.listaFechaHora}
        diasAdelante={this.props.diasAdelante}
        index={this.state.index}
        tipo={this.props.tipo}
        cantItemShow={this.state.cantItemShow}
        idDiaSelected={this.state.idDiaSelected}
        indiceDiaSelected={this.state.indiceDiaSelected}
        showModalTopeDias={this.state.showModalTopeDias}
        handleOnClickDia={this.handleOnClickDia}
        handleOnClickSiguiente={this.handleOnClickSiguiente}
        handleOnClickAnterior={this.handleOnClickAnterior}
        handleOnClickHorario={this.handleOnClickHorario}
        handleShowMsgTopeDias={this.handleShowMsgTopeDias}
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

function mapStateToProps() {
  return {};
}

TurneroContainer.propTypes = {
  listaFechaHora: PropTypes.array.isRequired,
  diasAdelante: PropTypes.number.isRequired,
  tipo: PropTypes.string.isRequired,
  handleOnClickDia: PropTypes.func.isRequired,
  handleOnClickHorario: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(TurneroContainer);
